import services from './../../services/service'; // Service Class
import MainHeader from './../Main-Header/index.vue'; // Dashboard Header
import Sidebar from './../Sidebar/index.vue'; // Dashboard Sidebar
import MainFooter from './../Main-Footer/index.vue'; // Dashboard Footer
let service = new services();

export default {
    name: 'Cnsurveys',
    data () {
        return {
            admin:{},
            cnsurveys: {},
            cnsurvey: {},
            activation_fee: 0,
            viewFlag: "",
            setDeleteSurvey: false
        }
    },
    components: {
        'component-header': MainHeader,
        'component-sidebar': Sidebar,
        'component-footer': MainFooter
    },
    methods: {
        //settings
        setPanel(attr,attr2) {
            this.panelFlag = true;
            if(attr == "view"){
                this.viewFlag = true;
                this.cnsurvey = attr2;
            }
            if(attr == "setDelete"){
                this.setDeleteSurvey = true;
            }
        },
        isActive(index){
            if(index == 1){
                return "active";
            }
        },
        preset() {
            var credentials = {
                session_key: localStorage.getItem("cityneeds_a_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.admin.admin_id = element.admin_id;
                        }, this);
                        }else {
                            this.$router.push('/');
                      }
                }).catch((err) => {
                    if(err) {
                     this.$router.push('/');
                    }
                })
            }else {
                this.$router.push('/');
            }
            
        },

        //quotes and contracts
        
        //get all saved listings
        getCnsurveys() {
            service.getSurveys(this).then(data => {
               if(data.body.status == 200) {
                    this.cnsurveys = data.body.data;
                 }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        approveSurvey(survey) {
            service.approveSurvey(this, survey, this.cnsurvey).then(data => {
               if(data.body.status == 200) {
                        toastr.success("Approved!", "Success!");
                        this.cnsurvey.cnsurvey_status = 13;
                        this.cnsurvey.cnsurvey_status_name = "Approved";
                    }else {
                        toastr.error('Sorry, could not approve', 'Warning!');
                    }
                }).catch((err) => {
                    if(err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                })
        },
        setActivationFee() {
            this.cnsurvey.cnsurvey_activation_fee = this.activation_fee;
            service.setActivationFee(this, this.cnsurvey.cnsurvey_id, this.cnsurvey).then(data => {
               if(data.body.status == 200) {
                        toastr.success("Set!", "Success!");
                        }else {
                        toastr.error('Sorry, could not approve', 'Warning!');
                    }
                }).catch((err) => {
                    if(err) {
                        toastr.error('Sorry, could not process information', 'Warning!');
                    }
                })
        },
        deleteSurvey(){
            service.deleteSurvey(this, this.cnsurvey.cnsurvey_id).then((response) => {
                if(response.body.status = 200) {
                    this.cnsurvey = []; this.viewFlag = false;
                    toastr.success("Survey Deleted", 'Successful'); 
                    //this.setDeleteSurvey = false;
                    this.$router.go('/cnsurveys');
                }else {
                    toastr.warning("Couldn't complete action, kindly try again", 'Warning!'); 
                }
            })
        },
        
    },
    created: function(){
        this.preset();
        this.getCnsurveys();
    }
}


// WEBPACK FOOTER //
// ./src/components/Cnsurveys/script.js